import dynamic from 'next/dynamic';

const MailBoxesGrid = dynamic(() => import('./MailBoxesGrid/MailBoxesGrid'));
const AddMailBoxModal = dynamic(() =>
  import('./AddMailBoxModal/AddMailBoxModal')
);

export { MailBoxesGrid, AddMailBoxModal };
